import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;
const MASTER_PATH = ['artifacts', appId, 'public', 'data', 'procuration_templates', 'master_v1'];
const AUTOSAVE_PATH = ['artifacts', appId, 'public', 'data', 'procuration_templates', 'cloud_autosave_v1'];
const CLIENTS_PATH = ['artifacts', appId, 'public', 'data', 'clients'];
const DOCUMENTS_PATH = ['artifacts', appId, 'public', 'data', 'documents'];

export async function fetchProcurationMasterV1() {
  const ref = doc(db, ...MASTER_PATH);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function fetchProcurationAutosave(docId) {
  const ref = doc(db, ...AUTOSAVE_PATH);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function saveProcurationAutosave(payload) {
  const ref = doc(db, ...AUTOSAVE_PATH);
  await setDoc(ref, { ...payload, source: 'cloud_autosave', updatedAt: serverTimestamp() });
}

export function subscribeProcurationMasterV1(callback) {
  const ref = doc(db, ...MASTER_PATH);
  return onSnapshot(ref, (snap) => {
    callback(snap.exists() ? snap.data() : null);
  });
}

export async function fetchClientData(clientId) {
  const ref = doc(db, ...CLIENTS_PATH, clientId);
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function getNextProcurationDocumentRef() {
  const col = collection(db, ...DOCUMENTS_PATH);
  return doc(col);
}

export async function updateProcurationDocument(docRef, payload) {
  await updateDoc(docRef, payload);
}

export async function publishProcurationDocument(docRef, payload) {
  await setDoc(docRef, payload, { merge: true });
}

export async function deleteProcurationDocument(docRef) {
  await deleteDoc(docRef);
}

export async function addProcurationProntuarioNote(clientId, note) {
  const notesRef = collection(db, ...CLIENTS_PATH, clientId, 'notes');
  await addDoc(notesRef, { ...note, createdAt: serverTimestamp() });
}

export async function fetchProcurationDocumentMeta(pubId) {
  const ref = doc(db, ...DOCUMENTS_PATH, pubId);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function deleteProcurationRelatedNotes(clientId, pubId) {
  const notesCol = collection(db, ...CLIENTS_PATH, clientId, 'notes');
  const notesSnap = await getDocs(query(notesCol));
  let deleted = 0;
  for (const noteDoc of notesSnap.docs) {
    const payload = noteDoc.data()?.payload;
    if (payload?.documentId === pubId) {
      await deleteDoc(noteDoc.ref);
      deleted++;
    }
  }
  return deleted;
}
